import React from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Button,
} from "@mui/material";
import { motion } from "framer-motion";

export default function SolutionCategory({
    id,
    title,
    description,
    products,
    bgColor = "#fff",
    ctaLink,
    ctaLabel,
}) {
    return (
        <Box
            id={id}
            sx={{
                bgcolor: bgColor,
                py: { xs: 6, md: 10 },
                scrollMarginTop: "80px",
            }}
        >
            <Container maxWidth="lg">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 800,
                            color: "primary.main",
                            mb: 1,
                            letterSpacing: "-0.02em",
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "text.secondary",
                            fontSize: "1.15rem",
                            mb: 4,
                            maxWidth: 800,
                        }}
                    >
                        {description}
                    </Typography>
                </motion.div>

                <Grid container spacing={4}>
                    {products.map((product, i) => (
                        <Grid item xs={12} sm={6} md={4} key={product.name}>
                            <motion.div
                                initial={{ opacity: 0, y: 28 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.06 * i, duration: 0.5 }}
                                whileHover={{ scale: 1.025 }}
                                style={{ height: "100%" }}
                            >
                                <Card
                                    sx={{
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 4,
                                        boxShadow: "0 3px 24px 0 rgba(20,76,100,0.07)",
                                        px: 2,
                                        py: 3,
                                    }}
                                >
                                    {product.logo && (
                                        <Box
                                            component="img"
                                            src={product.logo}
                                            alt={product.name}
                                            sx={{
                                                width: 56,
                                                height: 56,
                                                objectFit: "contain",
                                                borderRadius: 2,
                                                bgcolor: "#e7f5f6",
                                                mb: 2,
                                                alignSelf: "center",
                                            }}
                                        />
                                    )}
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 800,
                                                mb: 1,
                                                color: "primary.main",
                                                fontSize: "1.15rem",
                                            }}
                                        >
                                            {product.name}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: "text.secondary",
                                                fontSize: "1.02rem",
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            {product.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>

                {ctaLink && (
                    <Box sx={{ textAlign: "center", mt: 4 }}>
                        <Button
                            href={ctaLink}
                            variant="contained"
                            size="large"
                            component={motion.a}
                            whileHover={{ scale: 1.04 }}
                            whileTap={{ scale: 0.97 }}
                            sx={{
                                borderRadius: 99,
                                fontWeight: 700,
                                px: 5,
                                py: 1.3,
                                background: "linear-gradient(90deg, #145c8c, #21dbb8)",
                                fontSize: "1.08rem",
                            }}
                        >
                            {ctaLabel}
                        </Button>
                    </Box>
                )}
            </Container>
        </Box>
    );
}
